import { create } from 'zustand';
import { featureService, ClientFeature } from '../services/featureService';

interface FeatureState {
  features: ClientFeature[];
  loading: boolean;
  loaded: boolean;
  fetchFeatures: (clientId?: number) => Promise<void>;
  isFeatureEnabled: (featureCode: string) => boolean;
  hasBlacklistFeature: () => boolean;
  clear: () => void;
}

export const useFeatureStore = create<FeatureState>((set, get) => ({
  features: [],
  loading: false,
  loaded: false,

  fetchFeatures: async (clientId?: number) => {
    if (get().loading) return;
    
    console.log('🔍 fetchFeatures called, clientId:', clientId);
    set({ loading: true });
    try {
      // 客户使用 getMyFeatures（无需传 clientId），管理员查询指定客户使用 getClientFeatures
      const features = clientId 
        ? await featureService.getClientFeatures(clientId)
        : await featureService.getMyFeatures();
      console.log('✅ fetchFeatures success, features:', features);
      set({ features, loaded: true });
    } catch (error) {
      console.error('❌ 获取功能列表失败:', error);
      set({ features: [], loaded: true });
    } finally {
      set({ loading: false });
    }
  },

  isFeatureEnabled: (featureCode: string) => {
    const { features } = get();
    const feature = features.find(f => f.code === featureCode);
    return feature?.enabled ?? false;
  },

  hasBlacklistFeature: () => {
    const { features } = get();
    // 检查是否有任何黑名单相关功能开通
    return features.some(f => 
      (f.code === 'ip_blacklist' || f.code === 'fingerprint_blacklist') && f.enabled
    );
  },

  clear: () => {
    set({ features: [], loaded: false, loading: false });
  },
}));
